import React from 'react';
import { Svg, Path } from '@react-pdf/renderer';

const RadioButonUnchecked = () => (
  <Svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><Path fill="black" d="M12 22a10 10 0 1 1 10-10 10 10 0 0 1-10 10zm0-18a8 8 0 1 0 8 8 8 8 0 0 0-8-8z"/></Svg>
);

export default RadioButonUnchecked;
